import { GEM_FILES, buildGemCatalog } from "../constants/gems";
import { GAME_POTIONS } from "../constants/potions";
import { CLOVER_POTIONS } from "../constants/cloverPotions";
import { FAIRY_KEYS } from "../constants/keys";

// Préchauffage des visuels d'items (pierres, potions, parchemins).
//
// Pourquoi : ces images sont petites mais nombreuses (≈ 46 fichiers) et les
// cartes qui les affichent sont démontées / remontées à chaque changement
// d'onglet. Sans préchauffage, chaque montage déclenche un téléchargement ou
// au minimum un décodage asynchrone image par image, d'où un affichage
// « en cascade ». Ici, on télécharge ET décode tout une seule fois, en tâche
// de fond et en priorité réseau basse, dès que l'application est montée.
// On conserve une référence sur chaque HTMLImageElement pour que le navigateur
// garde les bitmaps décodés en mémoire pendant toute la session.
//
// Aucune attente n'est introduite côté affichage : les composants rendent
// leurs <img> normalement, elles sont simplement déjà prêtes.

const warmImages = new Map();
let warmupStarted = false;

export function collectItemImageUrls() {
  const urls = new Set();
  const add = (url) => {
    if (typeof url === "string" && url) urls.add(url);
  };

  buildGemCatalog(GEM_FILES).forEach((gem) => add(gem.imageUrl));
  GAME_POTIONS.forEach((potion) => add(potion.image));
  CLOVER_POTIONS.forEach((potion) => add(potion.image));
  FAIRY_KEYS.forEach((keyItem) => add(keyItem.image));

  return [...urls];
}

function warmOne(url) {
  if (warmImages.has(url)) return;
  const image = new Image();
  // Ne pas concurrencer les appels API / le bundle : priorité réseau basse.
  image.fetchPriority = "low";
  image.decoding = "async";
  image.onload = () => {
    if (typeof image.decode === "function") {
      image.decode().catch(() => {});
    }
  };
  image.onerror = () => {
    // Un fichier manquant ne doit pas bloquer les autres ; on retirera l'entrée
    // pour permettre une nouvelle tentative lors d'un prochain appel.
    warmImages.delete(url);
  };
  warmImages.set(url, image);
  image.src = url;
}

export function warmItemImages() {
  if (warmupStarted) return;
  if (typeof window === "undefined" || typeof Image === "undefined") return;
  warmupStarted = true;

  const run = () => {
    collectItemImageUrls().forEach(warmOne);
  };

  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(run, { timeout: 1500 });
  } else {
    window.setTimeout(run, 0);
  }
}

export function isItemImageWarm(url) {
  const image = warmImages.get(url);
  return Boolean(image && image.complete && image.naturalWidth > 0);
}
